import type { ComponentType } from 'react';
import useIsMobile from '/@/utils/hooks/is-mobile';
import { LoginForm, openPrivacyPolicy } from './login-form';

export { openPrivacyPolicy };

const LoginFormUntyped = LoginForm as unknown as ComponentType<Record<string, unknown> & { isMobile: boolean }>;

/**
 * Functional entry for the login route; composes the legacy LoginForm with responsive shell.
 * Post-login Experto→FieldView modal is global ({@link ExpertoFieldViewPostLoginModal} in App).
 *
 * Props are forwarded to the decorated class component (incomplete TS surface).
 */
export default function Login(props: Record<string, unknown>) {
    const isMobile = useIsMobile();
    return <LoginFormUntyped {...props} isMobile={isMobile} />;
}
